import React, { useEffect, useMemo } from "react";
import { Form, Select, Typography } from "antd";
import FormInput from "../Forms/FormInput";
import SelectTag from "../Forms/SelectTag";
import PrimaryButton from "../Forms/PrimaryButton";
import { formRules, idTypeEnums } from "../../constant";

const { Title } = Typography;

const Add = ({ type, handleFinish, formData = {}, title, prevStep }) => {
  const [form] = Form.useForm();
  const isClient = type === "client";

  const fn = (clientVal, userVal) => (isClient ? clientVal : userVal);

  const idTypeOptions = useMemo(
    () => (isClient ? idTypeEnums.client : idTypeEnums.user),
    [isClient]
  );

  useEffect(() => {
    form.setFieldsValue({ ...formData });
  }, [form, formData]);

  useEffect(() => {
    form.resetFields();
  }, [type, form]);

  return (
    <>
      <Title className="input-css font-abhaya" level={2}>
        {title}
      </Title>

      <Form
        form={form}
        className="mt-8"
        name="create-user"
        layout="vertical"
        autoComplete="off"
        onFinish={handleFinish}
        initialValues={{ ...formData }}
      >
        {/* Row 1 */}
        <div className="flex justify-between gap-4">
          <FormInput
            label={fn("Company Name", "Employee Name")}
            name={fn("company_name", "full_name")}
            rules={formRules.required}
            style={{ width: "48%" }}
          />
          <FormInput
            label={fn("Contact Person Name", "Designation")}
            name={fn("contact_person", "designation")}
            rules={formRules.required}
            style={{ width: "48%" }}
          />
        </div>

        {/* Row 2 */}
        <div className="flex justify-between gap-4">
          <FormInput
            label={fn("Company Email Address", "Email Address")}
            name="email"
            rules={formRules.email}
            style={{ width: "48%" }}
            type="text"
          />
          <FormInput
            label={fn("Company Contact No.", "Contact No.")}
            name="phone"
            rules={formRules.phone}
            maxLength={10}
            style={{ width: "48%" }}
          />
        </div>

        {/* Employee-only fields */}
        {!isClient && (
          <>
            <div className="flex justify-between gap-4">
              <FormInput
                label="Display Email Address"
                name="display_email_address"
                rules={formRules.email}
                style={{ width: "48%" }}
              />
              <FormInput
                label="Display Contact No."
                name="display_contact_no"
                maxLength={10}
                rules={formRules.phone}
                style={{ width: "48%" }}
              />
            </div>

            <Title level={5} className="text-center p-2 bg-[#FBEEEC] ">
              Residential Address
            </Title>

            <FormInput
              label="Address Line 1"
              name="residential_address_line_1"
              rules={formRules.required}
            />
            <FormInput
              label="Address Line 2"
              name="residential_address_line_2"
              rules={formRules.required}
            />

            <div className="flex justify-between gap-4 mt-4">
              <FormInput
                label="City"
                name="residential_city"
                rules={formRules.required}
                style={{ width: "48%" }}
              />
              <Form.Item
                label="State"
                name="residential_state"
                rules={formRules.required}
                style={{ width: "48%" }}
              >
                <SelectTag />
              </Form.Item>
            </div>

            <FormInput
              label="Postal Code"
              name="residential_postal_code"
              rules={formRules.postalCode}
              maxLength={6}
            />
          </>
        )}

        {/* Office Address */}
        {!isClient && (
          <Title level={5} className="text-center p-2 bg-[#FBEEEC] mt-6">
            Office Address
          </Title>
        )}

        <FormInput
          label="Address Line 1"
          name={fn("address_line1", "office_address_line_1")}
          rules={formRules.required}
        />
        <FormInput
          label="Address Line 2"
          name={fn("address_line2", "office_address_line_2")}
          rules={formRules.required}
        />

        <div className="flex justify-between gap-4 mt-4">
          <FormInput
            label="City"
            name={fn("city", "office_city")}
            rules={formRules.required}
            style={{ width: "48%" }}
          />
          <Form.Item
            label="State"
            name={fn("state", "office_state")}
            rules={formRules.required}
            style={{ width: "48%" }}
          >
            <SelectTag />
          </Form.Item>
        </div>

        <FormInput
          label="Postal Code"
          name={fn("post_code", "office_postal_code")}
          rules={formRules.postalCode}
          maxLength={6}
        />

        {/* Office Info */}
        
          <>
          {!isClient && (
            <Title level={5} className="text-center p-2 bg-[#FBEEEC] mt-6">
              Office Information
            </Title>
            )}

            <div className="flex justify-between gap-4">
              <FormInput label="Zone" name="zone" style={{ width: "48%" }} />
              <FormInput label="Area" name="area" style={{ width: "48%" }} />
            </div>
          </>
        

        <div className="flex justify-between gap-4">
          <Form.Item
            label="ID Type"
            name="id_type"
            rules={formRules.required}
            style={{ width: "48%" }}
          >
            <Select size="large" style={{ height: "47px" }} placeholder="Select ID Type">
              {idTypeOptions.map((opt) => (
                <Select.Option key={opt} value={opt}>
                  {opt}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <FormInput
            label="ID Number"
            name={fn("id_no", "id_number")}
            rules={formRules.required}
            style={{ width: "48%" }}
          />
        </div>

        {/* Agent info (client only) */}
        {isClient && (
          <div className="flex justify-between gap-4">
            <FormInput label="Agent Name" name="agent_name" style={{ width: "48%" }} />
            <FormInput
              label="Party Code"
              name="party_code"
              style={{ width: "48%" }}
              rules={formRules.partyCode}
              maxLength={10}
            />
          </div>
        )}

        <FormInput label="Remarks" name={fn("agent_remark", "remark")} />

        <div className="w-full mt-4 flex justify-evenly">
          {prevStep && (
            <PrimaryButton text="Cancel" type="cancel" onClick={prevStep} btnType="secondary" />
          )}
          <PrimaryButton text="Next" type="submit" className="me-[30px]" />
        </div>
      </Form>
    </>
  );
};

export default Add;
